import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from 'app/App.tsx'
import mixpanel from "mixpanel-browser";

mixpanel.init(import.meta.env.VITE_MIXPANEL_TOKEN, {
  debug: import.meta.env.VITE_MIXPANEL_DEBUG === "true",
  ignore_dnt: import.meta.env.VITE_MIXPANEL_IGNORE_DNT === "true",
  api_host: import.meta.env.VITE_MIXPANEL_API_HOST,
  // Cookie persistence keeps distinct_id consistent across ted.com subdomains.
  // See https://docs.mixpanel.com/docs/tracking-methods/sdks/javascript#hosted-subdomains
  secure_cookie: true,
  track_pageview: false,
});


createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
